import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/insumma.webp';
import screenshot_target from '../../../images/letterfunnel/antonvandaal.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Anton van Daal"
      firstname="Anton"
      companyname="In Summa"
      competition="FEMTO Engineering en Emixa"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/antonvandaal.js